module.exports = __webpack_public_path__ + "static/media/stack-line.7e7c9893.svg";